import { Stack, Typography, useTheme } from '@mui/material';
import Chart from 'react-apexcharts';
import { chartSeries, getChartOptions } from '../../config';
import WidgetWrapper from '../WidgetWrapper';

type Props = {
  type: 'continuous' | 'discrete';
  title: string;
  values: any[] | null;
  unit: string;
  isEditMode?: boolean;
  widgetId?: string;
  toggleAddOrRemoveHandler?: () => void;
  testId?: string;
};

export const TrendWidget = ({
  type,
  title,
  values,
  unit,
  isEditMode,
  widgetId,
  toggleAddOrRemoveHandler,
  testId,
}: Props) => {
  const options = getChartOptions(type);
  const series = values !== null ? chartSeries(values) : [];
  const theme = useTheme();
  return (
    <WidgetWrapper
      title={title}
      isEditMode={isEditMode}
      widgetId={widgetId!}
      toggleAddOrRemoveHandler={toggleAddOrRemoveHandler}
      testId={testId}
      isDataReady={values !== null}
      isTrendWidget={true}
      options={options}
      series={series}
      typeChart="area"
      unit={unit}
    >
      <Stack flexDirection={'row'}>
        <Stack sx={{ width: '12px', justifyContent: 'flex-end' }}>
          <Typography
            variant="caption"
            sx={{ transform: 'rotate(-90deg)', color: theme.palette.grey[500] }}
          >
            {unit}
          </Typography>
        </Stack>
        <Stack>
          <Chart options={options} series={series} type="area" width="100%" height="100%" />
        </Stack>
      </Stack>
    </WidgetWrapper>
  );
};

export default TrendWidget;
